import dynamicClass from 'clsx';
import { useCallback, useEffect, useRef } from 'react';
import grayXIcon from '../../../assets/images/icons/gray-x-icon.svg';
import okIcon from '../../../assets/images/icons/green-check-icon.svg';
import xIcon from '../../../assets/images/icons/red-x-icon.svg';
import './genericToast.scss';

interface GenericToastInterface {
    isOk?: boolean;
    icon?: any;
    message?: string;
    duration?: number;
    position?: string;
    size?: string;
    className?: string;
    setActiveToast: (boolean) => void;
}

const GenericToast = ({
    isOk,
    icon,
    message,
    duration,
    position,
    size,
    setActiveToast,
    className,
}: GenericToastInterface) => {
    // todas las props son opcionales y se explica su funcion a continuacion
    // isOk?: boolean; al mandarse en true el background del componente es magenta y en false es gris, ademas si no se manda icono hace que aparezca un simbolo de ok o x
    // icon?: any; es el icono que se quiere mostrar en el toast, si no se manda se toma el determinado por isOk
    // message?: string; mensaje que se queiere mostrar en el toast si no se manda se muestra uno generico
    // duration?: number; duracion en milisegundos del toast en pantalla por defecto 5 segundos
    // position?: string; up-left | up-right | up | down-left | down-right| down  referencia de que posicion desea que aparezca, por defecto up
    // size?: string; big | small referente al tamaño maximo del componente, big es un 100% y esta por default
    // setActiveToast: (boolean) => void es el setState que se le manda para que pueda esconderse
    // className?: string; clase que se le quiere agregar al componente

    const toastContainer = useRef<HTMLDivElement>(null);
    useEffect(() => {
        const timer = setTimeout(function () {
            closeToast();
        }, duration || 8000);
        return () => clearTimeout(timer);
    }, []);

    const closeToast = useCallback(() => {
        if (toastContainer.current) {
            toastContainer.current.classList.add('__hidden');
            setTimeout(function () {
                // eslint-disable-next-line no-lone-blocks
                {
                    toastContainer &&
                        toastContainer.current?.classList.remove('__hidden');
                    setActiveToast && setActiveToast(false);
                }
            }, 200);
        } else {
            setActiveToast && setActiveToast(false);
        }
    }, []);

    const classToast = dynamicClass('a-generic-toast', {
        [`--${position}`]: position,
        '--up': !position,
        [`--${size}`]: size,
        '--big': !size,
        [`${className}`]: className,
    });

    const messageToastValidator = isOk
        ? 'Realizado con exito'
        : 'Lo sentimos, ocurrió un error. Por favor inténtalo más tarde.';

    return (
        <div className={classToast} id="a-generic-toast" ref={toastContainer}>
            <div className={'a-generic-toast__content ' + (!isOk && '--gray')}>
                {icon ? (
                    <img src={icon} alt="toast icon" title="toast icon" />
                ) : (
                    <img
                        src={isOk ? okIcon : xIcon}
                        alt="toast icon"
                        title="toast icon"
                    />
                )}
                <p>{message || messageToastValidator}</p>
                <img
                    className="--close"
                    src={grayXIcon}
                    alt="toast close icon"
                    title="toast close icon"
                    onClick={closeToast}
                />
            </div>
        </div>
    );
};

export default GenericToast;
